import {
    FETCH_REFILL_LIST_FILTER,
    RESET_REFILL_LIST_FILTER,
    FETCH_REFILL_LIST_CHIP_FILTER,
  } from "../../constants/action.constants";
  
  const initialState = {
    filters: {},     
    chipFilters: [],    
  };
  
  const refillListFilterReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_REFILL_LIST_FILTER:
        return {
          ...state,
          filters: action.payload,
        };
  
      case FETCH_REFILL_LIST_CHIP_FILTER:
        return {
          ...state,
          chipFilters: action.payload,
        };
  
      case RESET_REFILL_LIST_FILTER:
        return initialState;
  
      default:
        return state;
    }
  };
  
  export default refillListFilterReducer;
  